// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WrapperScrollbar_wrapper__11Uhn","wrapper_type_thin":"WrapperScrollbar_wrapper_type_thin__VQptM"};